// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2LN7O","search":"Settings_search__6pbZ4","filter":"Settings_filter__1sgHQ"};